import { render, staticRenderFns } from "./adBanner.vue?vue&type=template&id=3b922505&scoped=true"
import script from "./adBanner.vue?vue&type=script&lang=js"
export * from "./adBanner.vue?vue&type=script&lang=js"
import style0 from "./adBanner.vue?vue&type=style&index=0&id=3b922505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b922505",
  null
  
)

export default component.exports